import src from "IMAGE";
export default { src, width: 71, height: 231, blurWidth: 2, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAICAYAAADTLS5CAAAASklEQVR42k3GsQmAMABFwQcOpNPpAgqxcAERO8eyEi1ECCGJjWDyyxQHxzQ2xvT1wOu6EGzrSLH65VNQKHLtnHKwrSwyEx+8v7EZCIAqfhUoiCwAAAAASUVORK5CYII="};
